import { gql } from '@apollo/client';

const MOVEMENT_FIELDS = gql`
  fragment InventoryMovementFields on InventoryMovement {
    id
    branch_id
    product_id
    kind
    quantity_delta
    unit_cost_cents
    reference_kind
    reference_id
    reason
    created_by
    created_at
  }
`;

export const INVENTORY_MOVEMENTS_QUERY = gql`
  ${MOVEMENT_FIELDS}
  query InventoryMovements(
    $offset: Int
    $limit: Int
    $product_id: ID
    $branch_id: ID
    $kind: InventoryMovementKind
  ) {
    inventoryMovements(
      offset: $offset
      limit: $limit
      product_id: $product_id
      branch_id: $branch_id
      kind: $kind
    ) {
      items {
        ...InventoryMovementFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const REGISTER_MOVEMENT_MUTATION = gql`
  ${MOVEMENT_FIELDS}
  mutation RegisterInventoryMovement($input: RegisterMovementInput!) {
    registerInventoryMovement(input: $input) {
      ...InventoryMovementFields
    }
  }
`;

export const LOW_STOCK_PRODUCTS_QUERY = gql`
  query LowStockProducts($limit: Int) {
    lowStockProducts(limit: $limit) {
      id
      code
      name
      stock_qty
      stock_min
      branch_id
    }
  }
`;

export const PRODUCT_LOOKUP_QUERY = gql`
  query ProductLookup($search: String, $limit: Int) {
    products(search: $search, limit: $limit, status_filter: ACTIVE) {
      items {
        id
        code
        name
        stock_qty
        stock_min
        branch_id
        is_batch_tracked
        is_perishable
      }
    }
  }
`;

const BATCH_FIELDS = gql`
  fragment InventoryBatchFields on InventoryBatch {
    id
    product_id
    product_code
    product_name
    lot_number
    expiration_date
    quantity_remaining
    quantity_received
    supplier_name
    status
    received_at
  }
`;

export const PRODUCT_BATCHES_QUERY = gql`
  ${BATCH_FIELDS}
  query ProductBatches($product_id: ID!) {
    productBatches(product_id: $product_id) {
      ...InventoryBatchFields
    }
  }
`;

export const EXPIRING_BATCHES_QUERY = gql`
  ${BATCH_FIELDS}
  query ExpiringBatches($limit: Int) {
    expiringBatches(limit: $limit) {
      ...InventoryBatchFields
    }
  }
`;

export const EXPIRED_BATCHES_QUERY = gql`
  ${BATCH_FIELDS}
  query ExpiredBatches($limit: Int) {
    expiredBatches(limit: $limit) {
      ...InventoryBatchFields
    }
  }
`;
